import { createStore, applyMiddleware, combineReducers } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'
import thunkMiddleware from 'redux-thunk'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import appState from 'store/AppState'
import categories from 'store/Categories'
import items from 'store/Items'
import menus from 'store/Menus'
import revenueCenters from 'store/RevenueCenters'
import salesEventTypes from 'store/SalesEventTypes'
import salesEvents from 'store/SalesEvents'
import priceLevels from 'store/PriceLevels'
import venues from 'store/Venues'
import VenueSettings from 'store/VenueSettings'
import serviceTypes from 'store/ServiceTypes'
import customPaymentTypes from 'store/CustomPaymentTypes'
import featureFlags from 'store/FeatureFlags'
import merchants from 'store/Merchants'
import itemMappings from 'store/ItemMappings'

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['venues'],
}

const persistVenuesConfig = {
  storage,
  key: 'venues',
  whitelist: ['selectedId'],
}

const persistAppStateConfig = {
  storage,
  key: 'appState',
  whitelist: ['user'],
}

const rootReducer = combineReducers({
  appState: persistReducer(persistAppStateConfig, appState),
  categories,
  items,
  menus,
  revenueCenters,
  salesEventTypes,
  salesEvents,
  priceLevels,
  serviceTypes,
  customPaymentTypes,
  merchants,
  VenueSettings,
  featureFlags,
  itemMappings,
  venues: persistReducer(persistVenuesConfig, venues),
})

const persistedReducer = persistReducer(persistConfig, rootReducer)
const middleware = composeWithDevTools(
  applyMiddleware(thunkMiddleware)
)

const store = () => {
  const store = createStore(persistedReducer, middleware)
  const persistor = persistStore(store)

  return { store, persistor }
}

export default store
